import { useQuery } from "react-query";
import axios from "axios";
import __ from "lodash";

import { getApiSitePrefix } from "../../functions/SiteDefaults";

const apiSitePrefix = getApiSitePrefix();

const getData = async (tableRef, queryClient, key, extraKeys, useCache) => {
  if (tableRef && tableRef.current && tableRef.current.state && tableRef.current.state.lastEditingRow){
    return queryClient.getQueryData(key);
  }
  if (useCache) {
    const cachedData = queryClient.getQueryData([...key, '_cached']);
    if (cachedData) return cachedData;
    const realData = queryClient.getQueryData(key);
    if (realData) return realData;
  }
  let extendedPath = "";
  if (extraKeys) {
    extendedPath = extraKeys.join("/");
  }
  const { data } = await axios.get(
    `${apiSitePrefix}/tariff/find/${extendedPath}`
  );
  return data;
};

export default function useTariffHeader(props) {
  const options = {
    ...props.options
  }
  let key = ['FindTariff'];

  const defaults = {
    origin: null,
    destination: null,
    companyUuid: null,
    chargeCode: null,
    chargeDate: null,
    promotionCode: " ",
    quantity: null,
    shcs: [],
    deck: "LOWER",
  }
  const paramKeys = Object.keys(defaults);

  const params = {...defaults, ...(__.pick(props, paramKeys))};
  for (let i = 0; i < paramKeys.length; i++) {
    if (params[paramKeys[i]] === null) {
      throw new Error(`Parameter ${paramKeys[i]} may not be null`);
    }
    if (params[paramKeys[i]] === "" || Array.isArray(params[paramKeys[i]]) && params[paramKeys[i]].length === 0) params[paramKeys[i]] = " ";
  }

  const extraKeys = [
    params.origin,
    params.destination,
    params.companyUuid,
    params.chargeCode,
    params.chargeDate,
    params.promotionCode,
    params.quantity,
    params.shcs,
    params.deck,
  ]


  key = [
    ...key,
    ...extraKeys
  ];

  const queryKey = [...key];
  if (props.useCache) {
    queryKey.push('_cached');
  }

  return useQuery(
    queryKey,
    () => getData(props.tableRef, props.queryClient, key, extraKeys, props.useCache),
    options
  );
}
